import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNotifications } from '../../contexts/NotificationContext';

/**
 * Composant pour afficher des avertissements de session via le système de notifications
 * Remplace les alert() par des notifications Material-UI discrètes
 */
const SessionWarning = () => {
  const { currentUser } = useAuth();
  const { addSystemNotification } = useNotifications();
  const [hasShownWarning, setHasShownWarning] = useState(false);

  useEffect(() => {
    // Vérifier s'il y a un avertissement de session à afficher
    const checkSessionWarning = () => {
      const warningShown = localStorage.getItem('auth_warning_shown');
      const shouldShowWarning = warningShown === 'true' && !localStorage.getItem('session_warning_dismissed');
      
      if (shouldShowWarning && currentUser && !hasShownWarning) {
        const warningMessage = currentUser.offlineMode 
          ? 'Mode hors ligne: certaines fonctionnalités peuvent être limitées'
          : 'Session expirée: certaines fonctionnalités peuvent ne pas fonctionner correctement';
        
        const notificationType = currentUser.offlineMode ? 'success' : 'error';
        
        addSystemNotification(warningMessage, notificationType);
        setHasShownWarning(true);
        
        // Marquer l'avertissement comme dismissé pour cette session
        localStorage.setItem('session_warning_dismissed', 'true');
      }
    };

    checkSessionWarning();
    
    // Vérifier périodiquement les changements
    const interval = setInterval(checkSessionWarning, 30000); // Toutes les 30 secondes
    
    return () => clearInterval(interval);
  }, [currentUser, addSystemNotification, hasShownWarning]);

  // Ce composant ne rend rien car il utilise maintenant le système de notifications
  return null;
};

export default SessionWarning; 